import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyLetters]',
  standalone: true
})
export class OnlyLettersDirective {
  @Input() maxLength?: number;

  constructor() {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    const sanitized = this.sanitize(input.value);

    input.value = sanitized;
  }

  private sanitize(value: string): string {
    let result = '';
    let prevChar: string | null = null;

    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      const isLetter = /[a-zA-Zа-яА-ЯёЁ]/.test(char);
      const isDash = char === '-';

      if (isLetter) {
        result += char;
        prevChar = char;
      } else if (isDash) {
        const isNotFirst = result.length > 0;
        const prevIsDash = prevChar === '-';

        if (isNotFirst && !prevIsDash) {
          result += char;
          prevChar = char;
        }
      }

      if (this.maxLength !== undefined && result.length >= this.maxLength) {
        break;
      }
    }

    return result;
  }
}
